import React from "react";
import { Link } from "react-router-dom";

export default function SecurityComplianceSection({ api }) {
  const track = "security-compliance";
  const t = api?.t || {};
  const lang = api?.lang || "en";
  const cfg = t?.programTracks?.securityCompliance || {};

  const returnTo = "/?noIntro=1#security-compliance-intake";

  const heading = cfg.heading || "Cybersecurity & Compliance Readiness";
  const startIntake = cfg.startIntake || "Start intake";
  const blurb = cfg.blurb || "Protect your organization, customers, and data. WOW50/50 supports practical cybersecurity education, risk basics, and compliance readiness pathways (including CMMC awareness).";
  const helpTitle = cfg.helpTitle || "How we can help";
  const helpBullets = Array.isArray(cfg.helpBullets) && cfg.helpBullets.length ? cfg.helpBullets : ["Cyber hygiene basics (passwords, MFA, phishing prevention).", "Data protection practices for small teams (policies + tools).", "CMMC / compliance awareness education and readiness steps (not certification).", "Vendor responsibility and security documentation support.", "Referrals to trusted partners for assessments and implementation."];
  const trackLabel = cfg.trackLabel || "Security & Compliance";
  const partnersTitle = cfg.partnersTitle || "For cybersecurity partners & compliance programs";
  const partnersBody1 = cfg.partnersBody1 || "We help participants understand requirements, take practical steps, and connect to verified providers for deeper work.";
  const partnersBody2 = cfg.partnersBody2 || "Partner with WOW50/50 to expand readiness education and responsible vendor practices.";

  const options = Array.isArray(cfg.options) && cfg.options.length
    ? cfg.options
    : [
        { id: "cmmc-awareness", label: "CMMC / compliance awareness" },
                { id: "data-protection", label: "Data protection practices" },
                { id: "policies", label: "Policies & documentation" },
                { id: "training", label: "Security training / awareness" },
                { id: "partnerships", label: "Partner / assessment referral" }
      ];

  return (
    <section id="security-compliance" className="scroll-mt-24 space-y-4">
      <div className="flex flex-wrap items-center gap-2">
        <h2 className="text-2xl sm:text-3xl font-semibold text-emerald-300">
          {heading}
        </h2>

        <Link
          to={`/intake?track=${encodeURIComponent(track)}&return=${encodeURIComponent(returnTo)}&lang=${encodeURIComponent(lang)}`}
          className="ml-auto inline-flex items-center justify-center rounded-full border border-emerald-400/30 bg-emerald-500/10 px-4 py-2 text-sm font-semibold text-emerald-200 hover:bg-emerald-500/15 transition"
        >
          {startIntake}
        </Link>
      </div>

      <div className="rounded-3xl border border-slate-800/70 bg-[#010916]/85 p-6 space-y-4">
        <p className="text-sm sm:text-base text-slate-200 max-w-4xl">
          {blurb}
        </p>

        <div className="grid gap-3 md:grid-cols-2">
          <div id="security-compliance-intake" className="rounded-2xl border border-slate-800 bg-[#010916]/78 p-4">
            <div className="text-sm font-semibold text-slate-100">{helpTitle}</div>
            <ul className="mt-2 list-disc pl-5 text-sm text-slate-200 space-y-1">
              {helpBullets.map((b, idx) => (
                <li key={idx}>{b}</li>
              ))}
            </ul>
          </div>

          <div className="rounded-2xl border border-slate-800 bg-[#010916]/78 p-4">
            <div className="text-sm font-semibold text-slate-100">{partnersTitle}</div>
            <div className="mt-2 text-sm text-slate-200 space-y-2">
              <p>{partnersBody1}</p>
              <p>{partnersBody2}</p>
            </div>
          </div>
        </div>
      </div>
    
      <div className="mt-6 rounded-2xl border border-slate-800 bg-[#010916]/70 p-4">
        <div className="text-sm font-semibold text-slate-100">Member Intake (required)</div>
        <p className="mt-1 text-xs text-slate-300">
          To request personalized support under this program, you must be an active WOW50/50 member and logged in.
        </p>
        <div className="mt-3">
          <Link
            to={"/intake?track=" + encodeURIComponent(track)}
            className="inline-flex items-center justify-center rounded-xl border border-cyan-400/40 bg-cyan-500/10 px-4 py-2 text-sm font-semibold text-cyan-200 hover:bg-cyan-500/15"
          >
            Go to Member Intake
          </Link>
        </div>
      </div>
</section>
  );
}
